import * as yup from 'yup'

export const CompanyInformationPreFilledSchema = yup
  .object({
    entityType: yup.string().required('Please select an entity type.'),
    ein: yup.string().required('Please enter a EIN number.').length(9, 'Must be 9 digits.'),
  })
  .required()

export type TCompanyInformationPreFilledSchema = yup.InferType<
  typeof CompanyInformationPreFilledSchema
>
